module.exports = __webpack_public_path__ + "static/media/YF87_4.27631caf.jpg";